var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('div',{staticClass:"school-logo"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"head_title"},[_vm._v("四川大学高等教育自学考试-校外教学点申请系统")])])])
}]

export { render, staticRenderFns }